import { exigirDefinicionCoherente } from '../formularios/definicion.js';
/**
 * Katz-15 · dependencia en actividades de la vida diaria · 0–15.
 *
 * Instrumento del RFC de Fundación (Laan W. *et al.*, *J Nutr Health Aging*
 * 2014;18(9):848–854), no el Katz de 6 ítems. Quince preguntas de sí/no con la
 * **redacción textual** del documento de Fundación (`Escalas/Katz 16.docx` — el
 * título dice 16 y las preguntas son quince).
 *
 * Tres reglas que lo separan del Katz clásico y que es fácil equivocar:
 *
 *   1. **Polaridad invertida.** "Sí, necesito ayuda" suma 1 punto de
 *      dependencia. Más puntaje es peor. Toda banda, color o dato de ejemplo que
 *      use la convención vieja (6 = independiente) está mal.
 *   2. **No es jerárquico.** Sin orden de severidad y sin skip-logic: se
 *      responden los quince siempre.
 *   3. **Dos puntajes.** El subtotal de los ítems 1 a 6 (0–6) es el que alimenta
 *      el semáforo; el total de los quince (0–15) es el dato completo del
 *      instrumento. Los dos se registran.
 *
 * El ítem 15 ("¿necesitás ayuda para caminar?") se solapa con el NMS y con el
 * CAS-E. No es un error del instrumento: conviene tenerlo presente al leer los
 * reportes para no contarlo como tres mediciones independientes.
 */
/** Los quince, con la redacción textual y su origen. */
const ITEMS = [
    { id: 'item-01', texto: '¿Necesitás ayuda para bañarte o ducharte?', origen: 'katz-6' },
    { id: 'item-02', texto: '¿Necesitás ayuda para vestirte?', origen: 'katz-6' },
    { id: 'item-03', texto: '¿Necesitás ayuda para ir al baño?', origen: 'katz-6' },
    {
        id: 'item-04',
        texto: '¿Necesitás ayuda para sentarte y levantarte de una silla?',
        origen: 'katz-6',
    },
    { id: 'item-05', texto: '¿Usás productos para la incontinencia?', origen: 'katz-6' },
    { id: 'item-06', texto: '¿Necesitás ayuda para comer?', origen: 'katz-6' },
    { id: 'item-07', texto: '¿Necesitás ayuda para usar el teléfono?', origen: 'lawton' },
    { id: 'item-08', texto: '¿Necesitás ayuda para hacer las compras?', origen: 'lawton' },
    { id: 'item-09', texto: '¿Necesitás ayuda para preparar la comida?', origen: 'lawton' },
    { id: 'item-10', texto: '¿Necesitás ayuda para cuidar tu casa?', origen: 'lawton' },
    { id: 'item-11', texto: '¿Necesitás ayuda para viajar?', origen: 'lawton' },
    { id: 'item-12', texto: '¿Necesitás ayuda para tomar tus medicamentos?', origen: 'lawton' },
    { id: 'item-13', texto: '¿Necesitás ayuda para manejar tus finanzas?', origen: 'lawton' },
    {
        id: 'item-14',
        texto: '¿Necesitás ayuda para cepillarte el cabello o afeitarte?',
        origen: 'extra',
    },
    { id: 'item-15', texto: '¿Necesitás ayuda para caminar?', origen: 'extra' },
];
export const ITEMS_KATZ15 = ITEMS.map((item) => item.id);
/** Los seis primeros: las actividades básicas que alimentan el semáforo. */
export const ITEMS_KATZ15_ADL = ITEMS.filter((item) => item.origen === 'katz-6').map((item) => item.id);
function preguntaDeItem(item) {
    return {
        id: item.id,
        texto: item.texto,
        campo: {
            tipo: 'binario',
            // "Sí" primero porque la pregunta se formula en positivo ("¿necesitás
            // ayuda?"): invertir el orden invita a contestar por inercia.
            etiquetaSi: 'Sí, necesito ayuda',
            etiquetaNo: 'No, puedo solo',
            puntosSi: 1,
            puntosNo: 0,
        },
        presentacion: { modo: 'lista' },
        opcional: false,
    };
}
export const FORMULARIO_KATZ15 = exigirDefinicionCoherente({
    id: 'katz-15',
    clase: 'escala',
    instrumento: 'katz15',
    titulo: 'Tu día a día',
    version: '1.0.0',
    estado: 'active',
    preguntas: ITEMS.map(preguntaDeItem),
});
//# sourceMappingURL=katz15.js.map